// miniapp/src/lib/ws.ts
export function openWS(onMsg: (m: any) => void) {
  const wsUrl =
    (location.protocol === "https:" ? "wss://" : "ws://") + location.host + "/ws";
  const ws = new WebSocket(wsUrl);
  ws.onmessage = (ev) => {
    try {
      onMsg(JSON.parse(ev.data));
    } catch {
      /* noop */
    }
  };
  return ws;
}